<div class="acc-tap">
  <h3 class="acc-tap-title">{{ "changePassword" | translate }}</h3>
  <hr class="m-0" />
  
  <!-- عرض رسائل الأخطاء العامة -->
  <div *ngIf="passwordForm.errors && submitted" class="mb-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded">
    <div *ngIf="passwordForm.errors?.['passwordMismatch']">
      {{ "passwordMismatchError" | translate }}
    </div>
    <div *ngIf="passwordForm.errors?.['sameAsCurrent']">
      {{ "newPasswordSameAsCurrentError" | translate }}
    </div>
  </div>

  <form [formGroup]="passwordForm" (ngSubmit)="onSubmit()" class="space-y-4">
    <div class="acc-tap-content">
      
      <!-- Current Password -->
      <div class="form-group">
        <label
          for="currentPassword"
          [class]="
            f['currentPassword'].touched
              ? f['currentPassword'].valid
                ? 'label-base text-green-500'
                : 'label-base text-red-500'
              : 'label-base'
          "
        >
          {{ "currentPasswordLabel" | translate }}
          <span>*</span>
        </label>

        <input
          type="password"
          id="currentPassword"
          formControlName="currentPassword"
          class="form-control border w-full p-2"
          maxlength="100"
          autocomplete="current-password"
          [ngClass]="{
            'border-red-500': f['currentPassword'].touched && f['currentPassword'].invalid,
            'border-green-500': f['currentPassword'].touched && f['currentPassword'].valid
          }"
        />

        <span
          *ngIf="f['currentPassword'].touched && f['currentPassword'].invalid"
          class="text-sm text-red-500"
        >
          {{ getErrorMessage('currentPassword') }}
        </span>
      </div>

      <!-- New Password -->
      <div class="form-group">
        <label
          for="newPassword"
          [class]="
            f['newPassword'].touched
              ? f['newPassword'].valid && !passwordForm.errors?.['sameAsCurrent']
                ? 'label-base text-green-500'
                : 'label-base text-red-500'
              : 'label-base'
          "
        >
          {{ "newPasswordLabel" | translate }}
          <span>*</span>
        </label>

        <input
          type="password"
          id="newPassword"
          formControlName="newPassword"
          class="form-control border w-full p-2"
          maxlength="100"
          autocomplete="new-password"
          [ngClass]="{
            'border-red-500': f['newPassword'].touched && 
                            (f['newPassword'].invalid || passwordForm.errors?.['sameAsCurrent']),
            'border-green-500': f['newPassword'].touched && 
                              f['newPassword'].valid && 
                              !passwordForm.errors?.['sameAsCurrent']
          }"
        />

        <span
          *ngIf="f['newPassword'].touched && (f['newPassword'].invalid || passwordForm.errors?.['sameAsCurrent'])"
          class="text-sm text-red-500"
        >
          <span *ngIf="f['newPassword'].errors">
            {{ getErrorMessage('newPassword') }}
          </span>
          <span *ngIf="passwordForm.errors?.['sameAsCurrent'] && !f['newPassword'].errors?.['required']">
            {{ "newPasswordSameAsCurrentError" | translate }}
          </span>
        </span>
      </div>

      <!-- Confirm New Password -->
      <div class="form-group">
        <label
          for="confirmNewPassword"
          [ngClass]="
            f['confirmNewPassword'].touched
              ? f['confirmNewPassword'].valid && !passwordForm.errors?.['passwordMismatch']
                ? 'label-base text-green-500'
                : 'label-base text-red-500'
              : 'label-base'
          "
        >
          {{ "confirmNewPasswordLabel" | translate }}
          <span>*</span>
        </label>

        <input
          type="password"
          id="confirmNewPassword"
          formControlName="confirmNewPassword"
          class="form-control border w-full p-2"
          maxlength="100"
          autocomplete="new-password"
          [ngClass]="{
            'border-red-500': f['confirmNewPassword'].touched &&
                            (f['confirmNewPassword'].invalid || passwordForm.errors?.['passwordMismatch']),
            'border-green-500': f['confirmNewPassword'].touched &&
                              f['confirmNewPassword'].valid &&
                              !passwordForm.errors?.['passwordMismatch']
          }"
        />

        <span
          *ngIf="f['confirmNewPassword'].touched && 
                 (f['confirmNewPassword'].invalid || passwordForm.errors?.['passwordMismatch'])"
          class="text-sm text-red-500"
        >
          <span *ngIf="f['confirmNewPassword'].errors?.['required']">
            {{ "confirmNewPasswordRequired" | translate }}
          </span>
          <span *ngIf="passwordForm.errors?.['passwordMismatch'] && !f['confirmNewPassword'].errors?.['required']">
            {{ "passwordMismatchError" | translate }}
          </span>
        </span>
      </div>

      <!-- Password Requirements -->
      <div class="password-requirements">
        <p>{{ "passwordRequirementsLabel" | translate }}</p>
        <ul class="list-disc list-inside text-sm text-gray-700">
          <li>{{ "passwordMinLength" | translate }}</li>
          <li>{{ "passwordSpecialChar" | translate }}</li>
          <li>{{ "passwordNumber" | translate }}</li>
          <li>{{ "passwordLowerCase" | translate }}</li>
          <li>{{ "passwordUpperCase" | translate }}</li>
          <li>{{ "newPasswordDifferent" | translate }}</li>
        </ul>
      </div>
    </div>

    <hr class="m-0" />
    <div class="acc-tap-footer">
      <button type="submit" class="main-btn">
        <i class="fa-regular fa-pen-to-square"></i>
        {{ "save" | translate }}
      </button>
    </div>
  </form>
</div>